<template>
    <div>
    <v-dialog v-model="dialog" persistent max-width="1300" content-class="custom-dialog">
        <v-card height="auto">
            <v-card-title>
                <div class="overline">提案電気図面依頼書(Proposal Denki Request)</div>
            </v-card-title>
            
    <v-container fluid>
        <v-tabs v-model="defaultTab" fixed-tabs centered color="white">
            <v-tabs-slider></v-tabs-slider>
                <v-tab justify="center" active-class="custom-tab">
                    1ST PAGE
                </v-tab>
                <v-tab justify="center" active-class="custom-tab">
                    2ND PAGE
                </v-tab>
                <v-tab justify="center" active-class="custom-tab">
                    3RD PAGE
                </v-tab>
                <v-tab justify="center" active-class="custom-tab">
                    4TH PAGE
                </v-tab>
                <v-tab justify="center" active-class="custom-tab">
                    5TH PAGE
                </v-tab>
                <v-tab justify="center" active-class="custom-tab">
                    6TH PAGE
                </v-tab>

                <!-- FIRST PAGE -->
                <v-tab-item>
                    <div>
                    <v-card flat>
                        <!-- <v-toolbar fixed flat height="30" style="background: #455a64; color:white;"> -->
                            <div class="font-weight-black mt-2" style="background: #455a64; color:white;width:100%;text-indent:10px;">照明・スイッチ配線</div>
                        <!-- </v-toolbar> -->
                        <v-card-text class="pa-5">
                            <div >
                                <h3 style="padding-top: 5px; display: inline;">（１）以下３肢のいずれか１つにチェックして下さい。</h3><span style="color:red; display: inline;">（複数選択不可）</span>
                            </div>
                            <v-radio-group v-model="shomei1" class="pl-11">
                                <template v-for="(option, i) in shomei1Options">
                                    <v-radio
                                        :label="option.text" 
                                        :value="option.value"
                                        :key="i"
                                        class="mb-n1">
                                    </v-radio>
                                    <p class="caption pl-8 grey--text mb-3">
                                        {{ option.desc }}
                                    </p>
                                </template>
                            </v-radio-group>

                            <div >
                                <h3 style="padding-top: 5px; display: inline;">（２）照明について、以下３肢のいずれか1つにチェックして下さい。</h3><span style="color:red; display: inline;">（複数選択不可）</span>
                            </div>
                            <v-radio-group v-model="shomei2" class="pl-11"> 
                                <v-radio v-model="shomeiOption1Obj.option1" value="1" label="①「ＬＥＤ照明パッケージ」対象 / LED Package"></v-radio>
                                <p v-if="shomei2 == 1" class="caption pl-8 pb-0 grey--text mb-3">⚫下記の計画をする場合は選択して下さい。</p>
                                <v-expand-transition>
                                    <div class="pl-8" v-if="shomei2 == 1">
                                        <form>
                                            <v-checkbox
                                                @click="pushToObj()"
                                                v-model="shomeiOption1Obj.sub_option.value"
                                                label="選択した部屋はデザインシーリングを計画する。/ Design the ceiling light with design ceiling"
                                                value="1"
                                                hide-details
                                                class="mt-0"
                                                >
                                            </v-checkbox>
                                                <div class="pl-8 pt-1" style="align-items: center;">
                                                    <!-- Checkboxes for 部屋名（ﾘﾋﾞﾝｸﾞ） -->
                                                    <span class="mb-0" style="display: inline-block;">部屋名（ﾘﾋﾞﾝｸﾞ）</span>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="room_CLN" label="CLN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="room_CLB" label="CLB" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="room_CLW" label="CLW　●　" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <!-- Checkboxes for ﾀﾞｲﾆﾝｸﾞ -->
                                                    <span class="mb-0" style="display: inline-block;">ﾀﾞｲﾆﾝｸﾞ</span>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="living_CLN" label="CLN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="living_CLB" label="CLB" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="living_CLW" label="CLW　●　" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <br>
                                                    <!-- Checkboxes for 主寝室 -->
                                                    <span class="mb-0" style="display: inline-block;">主寝室</span>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="master_CLN" label="CLN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="master_CLB" label="CLB" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="master_CLW" label="CLW　●　" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <!-- Text field and checkboxes for その他 -->
                                                    <span class="mb-0" style="display: inline-block;">その他</span>
                                                    <v-text-field @keypress.enter="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks_text" dense hide-details outlined rounded style="display: inline-block;"></v-text-field>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="others_CLN" label="CLN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="others_CLB" label="CLB" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption1Obj.sub_option.sub_option_remarks" value="others_CLW" label="CLW　●　" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                </div>
                                            <v-checkbox
                                                @click="pushToObj()"
                                                v-model="shomeiOption2Obj.sub_option.value"
                                                label="選択した部屋はシーリングではなく、ダウンライトで計画する。/ Design downlight instead of ceiling light."
                                                value="2"
                                                hide-details
                                                >
                                            </v-checkbox>
                                                <div class="pl-8 pt-1" style="align-items: center;">
                                                    <span class="mb-0" style="display: inline-block;">部屋名（ﾘﾋﾞﾝｸﾞ）</span>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="MN" value="room_MN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="ML" value="room_ML" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="MW　●　" value="room_MW" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <span class="mb-0" style="display: inline-block;">ﾀﾞｲﾆﾝｸﾞ</span>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="MN" value="living_MN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="ML" value="living_ML" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="MW　●　" value="living_MW" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <br>
                                                    <span class="mb-0" style="display: inline-block;">大壁和室</span>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="MN" value="japan_MN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="ML" value="japan_ML" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="MW　●　" value="japan_MW" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <span class="mb-0" style="display: inline-block;">その他</span>
                                                    <v-text-field @keypress.enter="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks_text" dense hide-details outlined rounded style="display: inline-block;"></v-text-field>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="MN" value="others_MN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="ML" value="others_ML" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption2Obj.sub_option.sub_option_remarks" label="MW　●　" value="others_MW" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                </div>
                                            <v-checkbox
                                                @click="pushToObj()"
                                                v-model="shomeiOption3Obj.sub_option.value"
                                                :label="longtext1"
                                                value="3"
                                                hide-details
                                                style="white-space: pre-line"
                                                >
                                            </v-checkbox>
                                                <div class="pl-8 pt-1" style="align-items: center; white-space: nowrap">
                                                    <span class="mb-0" style="display: inline-block;">部屋名（玄関･ﾎｰﾙ）</span>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MN" value="room_MN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="ML" value="room_ML" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MW　●　" value="room_MW" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <span class="mb-0">ﾎｰﾙ</span>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MN" value="hall_MN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="ML" value="hall_ML" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MW　●　" value="hall_MW" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <span class="mb-0" style="display: inline-block;">ﾄｲﾚ</span>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MN" value="toilet_MN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="ML" value="toilet_ML" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MW　●　" value="toilet_MW" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <br>
                                                    <span class="mb-0" style="display: inline-block;">書斎</span>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MN" value="study_MN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="ML" value="study_ML" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MW　●　" value="study_MW" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <span class="mb-0" style="display: inline-block;">ｷｯﾁﾝ</span>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MN" value="kitchen_MN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="ML" value="kitchen_ML" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MW　●　" value="kitchen_MW" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <span class="mb-0" style="display: inline-block;">その他</span>
                                                    <v-text-field @keypress.enter="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks_text" dense hide-details outlined rounded style="display: inline-block; width:120px !important"></v-text-field>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MN" value="others_MN" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="ML" value="others_ML" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption3Obj.sub_option.sub_option_remarks" label="MW　●　" value="others_MW" hide-details class="mt-0" style="display: inline-block; height: 34px;"></v-checkbox>
                                                </div>
                                            <v-checkbox
                                                @click="pushToObj()"
                                                v-model="shomeiOption4Obj.sub_option.value"
                                                label="吹き抜けの照明 "
                                                value="4"
                                                class="mb-0"
                                                hide-details
                                                >
                                                <!-- sd_ = Standard Downlight -->
                                            </v-checkbox>
                                                <div class="pl-8 mt-0">
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="標準（ダウンライト） / Standard Downlight in hukinuke" value="sd_hukinuke" hide-details></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="ブラケット（オリジナルLED) / Design wall mounted light in hukinuke （" value="dw_hukinuke" hide-details style="display: inline-block;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="LBL"  value="dw_LBL" hide-details style="display: inline-block;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="LBN ）" value="dw_LBN" hide-details style="display: inline-block;"></v-checkbox>
                                                    <div style="display: flex; align-items: center;">
                                                        <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="SP1L" value="SP1L" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                        <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="SP2L" value="SP2L" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                        <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="SP1N" value="SP1N" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                        <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="SP2N" value="SP2N" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                        <p style="display: inline-block; margin-bottom: 0px; margin-left: 20px;">スポットライトを選択 （</p>
                                                        <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="SP1L" value="sel_SP1L" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                        <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="SP2L" value="sel_SP2L" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                        <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="SP1N" value="sel_SP1N" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                        <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption4Obj.sub_option.sub_option_remarks" label="SP2N ）" value="sel_SP2N" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                    </div>
                                                </div>
                                            <v-checkbox
                                                @click="pushToObj()"
                                                v-model="shomeiOption5Obj.sub_option.value"
                                                label="勾配天井の照明 "
                                                value="5"
                                                hide-details
                                                >
                                            </v-checkbox>
                                                <div class="pl-8 mt-0">
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption5Obj.sub_option.sub_option_remarks" label="標準 (ダウンライト) / Standard Downlight in Sloped Ceiling （" value="sd_sloped" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption5Obj.sub_option.sub_option_remarks" label="KML" value="KML" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption5Obj.sub_option.sub_option_remarks" label="KMN" value="KMN" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption5Obj.sub_option.sub_option_remarks" label="KMW" value="KMW" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption5Obj.sub_option.sub_option_remarks" label="KLL" value="KLL" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption5Obj.sub_option.sub_option_remarks" label="KLN" value="KLN" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                    <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption5Obj.sub_option.sub_option_remarks" label="KLW ）" value="KLW" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                </div>
                                            <v-checkbox
                                                @click="pushToObj()"
                                                v-model="shomeiOption6Obj.sub_option.value"
                                                :label="longtext2"
                                                value="6"
                                                style="white-space: pre-line"
                                                hide-details
                                                >
                                            </v-checkbox>
                                            <div style="padding-left:35px; margin-top:0px !important">
                                                <v-row dense>
                                                    <v-col cols="6" class="pl-11 mt-0">
                                                        <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="ﾀﾞｲﾆﾝｸﾞﾃｰﾌﾞﾙ" value="MAIN_DINING" hide-details></v-checkbox>
                                                        <div class="pl-8 mt-0">
                                                            <div>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="Aライン（" value="DINE_A" hide-details style="margin-top: 0px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDAW" value="DINE_A_PDAW" hide-details style="margin-top: 0px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDAG" value="DINE_A_PDAG" hide-details style="margin-top: 0px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDAR" value="DINE_A_PDAR" hide-details style="margin-top: 0px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDAN ）" value="DINE_A_PDAN" hide-details style="margin-top: 0px; display: inline-block;"></v-checkbox>
                                                            </div>
                                                            <div>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="Ｉライン（" value="DINE_I" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDBWN" value="DINE_I_PDBWN" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDBM" value="DINE_I_PDBM" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDBB" value="DINE_I_PDBB" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDAW ）" value="DINE_I_PDAW" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                            </div>
                                                            <div>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="調光調色タイプ（" value="DIM_COLOR_DINE" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDC ）" value="DINE_COLOR_PDC" style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                            </div>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="6" class="mt-0">
                                                        <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="ｷｯﾁﾝｶｳﾝﾀｰ上" value="MAIN_KITCHEN" hide-details></v-checkbox>
                                                        <div class="pl-8 mt-0">
                                                            <div>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="Aライン（" value="KIT_A" hide-details style="margin-top: 0px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDAW" value="KIT_A_PDAW" hide-details style="margin-top: 0px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDAG" value="KIT_A_PDAG" hide-details style="margin-top: 0px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDAR" value="KIT_A_PDAR" hide-details style="margin-top: 0px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDAN ）" value="KIT_A_PDAN" hide-details style="margin-top: 0px; display: inline-block;"></v-checkbox>
                                                            </div>
                                                            <div>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="Ｉライン（" value="KIT_I" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDBWN" value="KIT_I_PDBWN" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDBM" value="KIT_I_PDBM" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDBB" value="KIT_I_PDBB" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDAW ）" value="KIT_I_PDAW" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                            </div>
                                                            <div>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="調光調色タイプ（" value="DIM_COLOR_KIT" hide-details style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                                <v-checkbox @click="pushSubRemToObj()" v-model="shomeiOption6Obj.sub_option.sub_option_remarks" label="PDC ）" value="KIT_COLOR_PDC" style="margin-top: 2px; display: inline-block;"></v-checkbox>
                                                            </div>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </form>
                                    </div>
                                </v-expand-transition>

                                <v-radio value="2" label="②指定推奨カタログからの商品選択でおまかせ / Non LED Campaign"></v-radio>
                                <v-radio value="3" label="③全て図面に従う  / Follow the Request" class="mb-n1"></v-radio>
                                <p class="caption pl-8 grey--text mb-3">※全て添付ＣＡＤ図面（配線位置が記入されたもの）通りに作図する場合はここをチェックして下さい。</p>
                            </v-radio-group>

                            <div >
                                <h3 style="padding-top: 5px; display: inline;">（３）「ネームスイッチ」について、以下４肢のいずれか１つにチェックしてください。</h3><span style="color:red; display: inline;">（複数選択不可）</span>
                            </div>
                            <v-radio-group v-model="shomei3" class="pl-11">
                                <template v-for="(option, i) in shomei3Options">
                                    <v-radio
                                        :label="option.text" 
                                        :value="option.value"
                                        :key="i"
                                        class="mb-n1">
                                    </v-radio>
                                    <p class="caption pl-8 grey--text mb-3">
                                        {{ option.desc }}
                                    </p>
                                </template>
                            </v-radio-group>
                        </v-card-text>
                        <!-- <v-card-actions>
                            <v-spacer></v-spacer>
                                <v-btn dark color="red" @click="cancelProposal">キャンセル</v-btn>
                                <v-btn dark color="green" @click="submitProposal">保存</v-btn>
                        </v-card-actions> -->
                    </v-card>
                </div>
                </v-tab-item>

                <!-- SECOND PAGE -->
                <v-tab-item>
                    <v-card flat>
                        <!-- <v-toolbar fixed flat height="30" style="background: #455a64; color:white"> -->
                            <div class="font-weight-black mt-2" style="background: #455a64; color:white;width:100%;text-indent:10px;">コンセント配線</div>
                        <!-- </v-toolbar> -->
                        <v-card-text class="pa-5">
                            <div >
                                <h3 style="padding-top: 5px; display: inline;">（１）以下３肢のいずれか１つにチェックして下さい。</h3><span style="color:red; display: inline;">（複数選択不可）</span>
                            </div>
                            <v-radio-group v-model="outlet" class="pl-11">
                                <template v-for="(option, i) in outletOptions">
                                    <v-radio
                                        :label="option.text" 
                                        :value="option.value"
                                        :key="i"
                                        class="mb-n1"
                                    >
                                    </v-radio>
                                    <p class="caption pl-8 grey--text mb-3">
                                        {{ option.desc }}
                                    </p>
                                </template>
                            </v-radio-group>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                    
                <!-- THIRD PAGE -->
                <v-tab-item>
                    <v-card flat>
                        <!-- <v-toolbar fixed flat height="30" style="background: #455a64; color:white"> -->
                            <div class="font-weight-black mt-2" style="background: #455a64; color:white;width:100%;text-indent:10px;">スイッチ・コンセントのオプションアイテム</div>
                        <!-- </v-toolbar> -->
                        <v-card-text class="pa-5">
                            <div >
                                <h3 style="padding-top: 5px; display: inline;">（１）採用するものにチェックを入れ、計画する照明に○をつけて下さい。</h3>
                            </div>

                            <!-- Start -->
                            <v-row dense> 
                                <v-col cols="5" class="pb-0">
                                    <v-checkbox @click="pushToSwitchObj()" v-model="switchesOption1Obj.option1" value="1" class="pl-11" hide-details label="かってにスイッチ"></v-checkbox>
                                </v-col>
                                <v-col align-self="end" class="pt-0 pb-0">
                                    <v-btn-toggle v-model="switchesOption1Obj.sub_outlet.sub_outlet_remarks" group dense multiple>
                                        <v-btn
                                            style="display:inline-block"
                                            height="10px"
                                            v-for="(item, i) in group_button1"
                                            :key="i"
                                            :value="item.value"
                                            @click="toggle1(i),pushSubOutletObj()" 
                                            text
                                            x-small
                                            > 
                                            <span :class="{ 'clicked-style': toggle_multiple1[i] }" >{{ item.text }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                <!-- </v-col>
                                <v-col align-self="end" class="pb-0 pl-5" v-if="toggle_multiple1[1] == true"> -->
                                    <v-text-field v-model="switchesOption1Obj.sub_outlet.sub_option_remarks_text" outlined rounded dense hide-details
                                        v-if="toggle_multiple1[1] == true"
                                        style="display:inline-block; width:150px !important; height:20px !important"
                                        >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <!-- End -->

                            <!-- Start -->
                            <v-row dense>
                                <v-col cols="5" class="pt-0 pb-0">
                                    <v-checkbox @click="pushToSwitchObj()" v-model="switchesOption2Obj.option2" value="2" class="pl-11" hide-details label="あけたらタイマ  (Switch for 電灯配線取出 only) "></v-checkbox>
                                </v-col>
                                <v-col align-self="end" class="pt-0 pb-0">
                                    <v-btn-toggle v-model="switchesOption2Obj.sub_outlet.sub_outlet_remarks" group dense multiple>
                                        <v-btn 
                                            style="display:inline-block"
                                            height="10px"
                                            v-for="(item, i) in group_button2"
                                            :key="i"
                                            :value="item.value"
                                            @click="toggle2(i),pushSubOutletObj()" 
                                            text
                                            x-small
                                            > 
                                            <span :class="{ 'clicked-style': toggle_multiple2[i] }" >{{ item.text }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                <!-- </v-col>
                                <v-col align-self="end" class="pt-0 pb-0 pl-5" v-if="toggle_multiple2[6] == true"> -->
                                    <v-text-field v-model="switchesOption2Obj.sub_outlet.sub_option_remarks_text" outlined rounded dense hide-details
                                        style="display:inline-block; width:120px !important; height:20px !important"
                                        v-if="toggle_multiple2[6] == true"
                                        >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <!-- End -->

                            <!-- Start -->
                            <v-row dense>
                                <v-col cols="5" class="pt-0 pb-0">
                                    <v-checkbox @click="pushToSwitchObj()" v-model="switchesOption3Obj.option3" value="3" class="pl-11" hide-details label="あけたらコンセント "></v-checkbox>
                                </v-col>
                                <v-col align-self="end" class="pt-0 pb-0">
                                    <v-btn-toggle v-model="switchesOption3Obj.sub_outlet.sub_outlet_remarks" group dense multiple>
                                        <v-btn 
                                            style="display:inline-block"
                                            height="10px"
                                            v-for="(item, i) in group_button3"
                                            :key="i"
                                            :value="item.value"
                                            @click="toggle3(i),pushSubOutletObj()" 
                                            text
                                            x-small
                                            > 
                                            <span :class="{ 'clicked-style': toggle_multiple3[i] }" >{{ item.text }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                <!-- </v-col>
                                <v-col align-self="center" class="pt-0 pb-0 pl-5" v-if="toggle_multiple3[6] == true"> -->
                                    <v-text-field v-model="switchesOption3Obj.sub_outlet.sub_outlet_remarks_text" outlined rounded dense hide-details
                                        style="display:inline-block; width:150px !important; height:20px !important"
                                        v-if="toggle_multiple3[6] == true"
                                        >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <!-- End -->

                            <!-- Start -->
                            <v-row dense>
                                <v-col cols="5" class="pt-0 pb-0">
                                    <v-checkbox @click="pushToSwitchObj()" v-model="switchesOption4Obj.option4" value="4" class="pl-11" hide-details label="LED用ライコン"></v-checkbox>
                                    <div class="pl-8"><p class="pl-11 black--text mb-3" style="font-size:10px">※ライコンを選択した部屋はメーカー照明のダウンライトで計画します。</p></div>
                                </v-col>
                                <v-col align-self="center" class="pt-0 pb-0">
                                    <v-btn-toggle v-model="switchesOption4Obj.sub_outlet.sub_outlet_remarks" group dense multiple>
                                        <v-btn 
                                            style="display:inline-block"
                                            height="10px"
                                            v-for="(item, i) in group_button4"
                                            :key="i"
                                            :value="item.value"
                                            @click="toggle4(i),pushSubOutletObj()" 
                                            text
                                            x-small
                                            > 
                                            <span :class="{ 'clicked-style': toggle_multiple4[i] }" >{{ item.text }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                <!-- </v-col>
                                <v-col align-self="center" class="pt-0 pb-0 pl-5" v-if="toggle_multiple4[6] == true"> -->
                                    <v-text-field v-model="switchesOption4Obj.sub_outlet.sub_outlet_remarks_text" outlined rounded dense hide-details 
                                        style="display:inline-block; width:150px !important"
                                        v-if="toggle_multiple4[6] == true"
                                        >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <!-- End -->

                            <!-- Start -->
                            <v-row dense>
                                <v-col cols="5" class="pt-0 pb-0">
                                    <v-checkbox @click="pushToSwitchObj()" v-model="switchesOption5Obj.option5" value="5" class="pl-11" hide-details label="とったらリモコンを計画する。"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row dense style="padding-left:30px"> 
                                <v-col cols="5" class="pb-0 pl-10">
                                    <v-checkbox @click="pushSubOutletObj()" v-model="switchesOption5Obj.sub_outlet_with.value" value="with" class="pl-11" hide-details label="WITH 遅れ消灯機能あり"></v-checkbox>
                                </v-col>
                                <v-col align-self="end" class="pt-0 pb-0">
                                    <v-btn-toggle v-model="switchesOption5Obj.sub_outlet_with.sub_outlet_remarks" group dense multiple>
                                        <v-btn 
                                            style="display:inline-block"
                                            height="10px"
                                            v-for="(item, i) in group_button5"
                                            :key="i"
                                            :value="item.value"
                                            @click="toggle5(i),pushSubOutletObj()" 
                                            text
                                            small
                                            > 
                                            <span :class="{ 'clicked-style': toggle_multiple5[i] }" >{{ item.text }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                <!-- </v-col>
                                <v-col align-self="center" class="pt-0 pb-0 pl-5" v-if="toggle_multiple5[5] == true"> -->
                                    <v-text-field outlined rounded dense hide-details 
                                        style="display:inline-block; width:200px !important; height:20px !important"
                                        v-if="toggle_multiple5[5] == true"
                                        >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row dense style="padding-left:30px"> 
                                <v-col cols="5" class="pb-0 pl-10">
                                    <v-checkbox @lick="pushSubOutletObj()" v-model="switchesOption5Obj.sub_outlet_without.value" value="without" class="pl-11" hide-details label="WITHOUT 遅れ消灯なし"></v-checkbox>
                                </v-col>
                                <v-col align-self="end" class="pt-0 pb-0">
                                    <v-btn-toggle v-model="switchesOption5Obj.sub_outlet_without.sub_outlet_remarks" group dense multiple>
                                        <v-btn 
                                            style="display:inline-block"
                                            height="10px"
                                            v-for="(item, i) in group_button5"
                                            :key="i"
                                            :value="item.value"
                                            @click="toggle6(i),pushSubOutletObj()" 
                                            text
                                            small
                                            > 
                                            <span :class="{ 'clicked-style': toggle_multiple6[i] }" >{{ item.text }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                <!-- </v-col>
                                <v-col align-self="center" class="pt-0 pb-0 pl-5" v-if="toggle_multiple6[5] == true"> -->
                                    <v-text-field outlined rounded dense hide-details 
                                        style="display:inline-block; width:200px !important; height:20px !important"
                                        v-if="toggle_multiple6[5] == true"
                                        >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <!-- End -->

                            <!-- Start -->
                            <v-row dense>
                                <v-col cols="5" class="pt-0 pb-0">
                                    <v-checkbox @click="pushToSwitchObj()" v-model="switchesOption6Obj.option6" value="6" class="pl-11" hide-details label="EV･PHEV充電専用E付"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row dense style="padding-left:30px"> 
                                <v-col cols="5" class="pb-0 pl-10">
                                    <v-checkbox @click="pushSubOutletObj()" v-model="switchesOption6Obj.sub_outlet.sub_outlet_remarks" value="EVPHEV_switch" class="pl-11" hide-details label="ｽｲｯﾁ有り"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row dense style="padding-left:30px"> 
                                <v-col cols="5" class="pb-0 pl-10">
                                    <v-checkbox @click="pushSubOutletObj()" v-model="switchesOption6Obj.sub_outlet.sub_outlet_remarks" value="EVPHEV_without" class="pl-11" hide-details label="ｽｲｯﾁ無し"></v-checkbox>
                                </v-col>
                            </v-row>
                            <!-- End -->

                            <!-- Start -->
                            <v-row dense>
                                <v-col cols="5" class="pt-0 pb-0">
                                    <v-checkbox @click="pushToSwitchObj()" v-model="switchesOption7Obj.option7" value="7" class="pl-11" hide-details label="足元灯 / Foot light"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row dense style="padding-left:30px"> 
                                <v-col cols="5" class="pb-0 pl-10">
                                    <v-checkbox @click="pushSubOutletObj()" v-model="switchesOption7Obj.sub_outlet_thermal.value" value="footlight_thermal" class="pl-11" hide-details label="熱線センサ/ footlight thermal sensor type"></v-checkbox>
                                </v-col>
                                <v-col align-self="end" class="pt-0 pb-0">
                                    <v-btn-toggle v-model="switchesOption7Obj.sub_outlet_thermal.sub_outlet_remarks" group dense multiple>
                                        <v-btn 
                                            style="display:inline-block"
                                            height="10px"
                                            v-for="(item, i) in group_button6"
                                            :key="i"
                                            :value="item.value"
                                            @click="toggle7(i),pushSubOutletObj()" 
                                            text
                                            small
                                            > 
                                            <span :class="{ 'clicked-style': toggle_multiple7[i] }" >{{ item.text }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                <!-- </v-col>
                                <v-col align-self="center" class="pt-0 pb-0 pl-5" v-if="toggle_multiple7[2] == true"> -->
                                    <v-text-field outlined rounded dense hide-details 
                                        style="display:inline-block; width:200px !important; height:20px !important"
                                        v-if="toggle_multiple7[2] == true"
                                        >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            
                            <div style="padding-bottom:30px">
                                <v-row dense style="padding-left:30px"> 
                                    <v-col cols="5" class="pl-10">
                                        <v-checkbox @click="pushSubOutletObj()" v-model="switchesOption7Obj.sub_outlet_sensor.value" value="footlight_sensor" class="pl-11" hide-details label="明るさセンサ/ footlight sensor type"></v-checkbox>
                                    </v-col>
                                    <v-col align-self="end" class="pt-0">
                                        <v-btn-toggle v-model="switchesOption7Obj.sub_outlet_sensor.sub_outlet_remarks" group dense multiple>
                                            <v-btn 
                                                style="display:inline-block"
                                                height="10px"
                                                v-for="(item, i) in group_button6"
                                                :key="i"
                                                :value="item.value"
                                                @click="toggle8(i),pushSubOutletObj()" 
                                                text
                                                small
                                                > 
                                                <span :class="{ 'clicked-style': toggle_multiple8[i] }" >{{ item.text }}</span> 
                                            </v-btn>
                                        </v-btn-toggle>
                                    <!-- </v-col>
                                    <v-col align-self="center" class="pt-0 pb-0 pl-5" v-if="toggle_multiple8[2] == true"> -->
                                        <v-text-field outlined rounded dense hide-details 
                                            style="display:inline-block; width:200px !important; height:20px !important"
                                            v-if="toggle_multiple8[2] == true"
                                            >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
                            <!-- End -->
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                                <v-btn dark color="red" @click="cancelProposal">キャンセル</v-btn>
                                <v-btn dark color="green" @click="submitProposal">保存</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-tab-item>

                <!-- FOURTH PAGE -->
                <v-tab-item>
                    <v-card flat>
                        <!-- <v-toolbar fixed flat height="30" style="background: #455a64; color:white"> -->
                            <div class="font-weight-black mt-2" style="background: #455a64; color:white;width:100%;text-indent:10px;">インターホン</div>
                        <!-- </v-toolbar> -->
                        <v-card-text class="pa-5">
                            <v-checkbox 
                                class="pl-11 mt-0"
                                label="	標準のまま（位置おまかせ）※「MT101」を任意の場所に計画します。以下のチェック不要　/ Same as Standard Plan	"
                                >
                            </v-checkbox>
                            <!-- <hr> -->
                            <div >
                                <h3 style="padding-top: 5px; display: inline;">（１）インタ-ホン タイプにチェックして下さい。 / Interphone Type</h3>
                            </div>
                            <v-row dense>
                                <v-col v-for="(imageName, index) in image_name1" :key="index" cols="3">
                                    <v-checkbox class="pl-11">
                                    <template v-slot:label>
                                        <span>{{ imageName }}</span>
                                        <v-img :src="`./img/${imageName}.png`" :max-height="getMaxHeight(imageName)" :max-width="getMaxWidth(imageName)"></v-img>
                                    </template>
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col v-for="(imageName, index) in image_name2" :key="index" cols="4">
                                    <v-checkbox class="pl-11">
                                    <template v-slot:label>
                                        <span>{{ imageName }}</span>
                                        <v-img :src="`./img/${imageName}.png`" :max-height="getMaxHeight(imageName)" :max-width="getMaxWidth(imageName)"></v-img>
                                    </template>
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <!-- <v-row dense>
                                <v-col cols="3">
                                    <v-checkbox class="pl-11">
                                        <template v-slot:label>
                                            <span>MT101（標準）</span>
                                            <v-img src="./img/image001.png" max-height="210" max-width="250"></v-img>
                                            <v-img src="./img/image001.gif" max-height="210" max-width="250"></v-img>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="3">
                                    <v-checkbox class="pl-11">
                                        <template v-slot:label>
                                            <span >MT102</span>
                                            <v-img src="./img/mt102.PNG" max-height="160" max-width="250"></v-img>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="3">
                                    <v-checkbox class="pl-11">
                                        <template v-slot:label>
                                            <span >MT103</span>
                                            <v-img src="./img/mt103.PNG" max-height="160" max-width="250"></v-img>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="3">
                                    <v-checkbox class="pl-11">
                                        <template v-slot:label>
                                            <span >MT104</span>
                                            <v-img src="./img/mt104.png" max-height="160" max-width="250"></v-img>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                            </v-row> -->
                            <!-- <v-row dense>
                                <v-col cols="4">
                                    <v-checkbox class="pl-11">
                                        <template v-slot:label>
                                            <span >MT105</span>
                                            <v-img src="./img/mt105.png" max-height="150" max-width="250"></v-img>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox class="pl-11">
                                        <template v-slot:label>
                                            <span >MT91</span>
                                            <v-img src="./img/mt91.png" max-height="150" max-width="250"></v-img>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                                <v-col cols="4">
                                    <v-checkbox class="pl-11">
                                        <template v-slot:label>
                                            <span >MT92</span>
                                            <v-img src="./img/mt92.png" max-height="150" max-width="250"></v-img>
                                        </template>
                                    </v-checkbox>
                                </v-col>
                            </v-row> -->

                            <div >
                                <h3 style="padding-top: 5px; display: inline;">（２）設置場所を指示して下さい。/ Place interphone unit in requested room</h3>
                            </div>

                            <div >
                                <h3 class="pt-3 pl-11">• 玄関子機①　（以下４つの部屋のいずれか１つに○をつける）  / The encircled room below is the location of entrance interphone slave unit①</h3>
                                <v-btn-toggle v-model="toggle_interphone1" dense multiple class="pt-1 pl-7 ml-7">
                                    <v-btn 
                                        v-for="(item, i) in group_interphone1"
                                        :key="i"
                                        :value="item"
                                        @click="toggleIP1(i)" 
                                        > 
                                        <span :class="{ 'clicked-style': toggle_interphone1[i] }" >{{ item }}</span> 
                                    </v-btn>
                                </v-btn-toggle>
                            </div>

                            <div >
                                <h3 class="pt-3 pl-11">• 玄関子機②　（以下４つの部屋のいずれか１つに○をつける）  / The encircled room below is the location of entrance interphone slave unit②</h3>
                                <h3 class="pt-3 pl-14">※ MT104, MT105  の場合のみチェック。</h3>
                                <v-btn-toggle v-model="toggle_interphone2" dense multiple class="pt-1 pl-7 ml-7">
                                    <v-btn 
                                        v-for="(item, i) in group_interphone1"
                                        :key="i"
                                        :value="item"
                                        @click="toggleIP2(i)" 
                                        > 
                                        <span :class="{ 'clicked-style': toggle_interphone2[i] }" >{{ item }}</span> 
                                    </v-btn>
                                </v-btn-toggle>
                            </div>

                            <div >
                                <h3 class="pt-3 pl-11">• モニター親機　（以下の部屋のいずれか１つに○をつける）  / Place the maste</h3>
                                <div class="d-flex align-center">
                                    <v-btn-toggle v-model="toggle_interphone3" dense multiple class="pt-1 pl-7 ml-7">
                                        <v-btn 
                                            v-for="(item, i) in group_interphone2"
                                            :key="i"
                                            :value="item"
                                            @click="toggleIP3(i)" 
                                            > 
                                            <span :class="{ 'clicked-style': toggle_interphone3[i] }" >{{ item }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                    <td class="ml-5" v-if="toggle_interphone3[9] == true">
                                        <v-text-field outlined rounded dense hide-details width="120px"></v-text-field>
                                    </td>
                                </div>
                            </div>

                            <div>
                                <h3 class="pt-3 pl-11">• 増設機 or スピーカー　（以下の部屋のいずれか１つに○をつける）  / Place the e</h3>
                                <h3 class="pt-3 pl-14">※MT102、MT103、MT105 の場合のみチェック。</h3>
                                <div class="d-flex align-center">
                                    <v-btn-toggle v-model="toggle_interphone4" dense multiple class="pt-1 pl-7 ml-7">
                                        <v-btn 
                                            v-for="(item, i) in group_interphone2"
                                            :key="i"
                                            :value="item"
                                            @click="toggleIP4(i)" 
                                            > 
                                            <span :class="{ 'clicked-style': toggle_interphone4[i] }" >{{ item }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                    <td class="ml-5" v-if="toggle_interphone4[9] == true">
                                        <v-text-field outlined rounded dense hide-details width="120px"></v-text-field>
                                    </td>
                                </div>
                            </div>

                            <div class="pl-8" style="padding-bottom:20px">
                                <v-checkbox label="図面に従う  / Follow the Request" hide-details></v-checkbox>
                                <p class="caption pl-8 grey--text mb-3">※位置を指示したＣＡＤ図面を添付して下さい。</p>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <!-- FIFTH PAGE -->
                <v-tab-item>
                    <v-card flat style="overflow-y:auto;">
                        <!-- <v-toolbar fixed flat height="30" style="background: #455a64; color:white;" class="sticky-title"> -->
                            <div class="font-weight-black mt-2" style="background: #455a64; color:white;width:100%;text-indent:10px;">TV・TEL・LANおよびその他の計画	</div>
                        <!-- </v-toolbar> -->
                        <v-card-text class="pa-5">
                            <v-checkbox 
                                class="pl-11 mt-0"
                                label="標準のまま（位置おまかせ）　※以下のチェック不要　/ Same as Standard Plan"
                                >
                            </v-checkbox>
                            <div >
                                <h3 style="padding-top: 5px; padding-bottom:3px">（１）情報コンセント・TV・TEL・LANの計画</h3>
                                <h4 style="margin-left:40px">計画する部屋と線種を○で囲って下さい。/ Encircle room name ＆ items for TV, TEL, LAN ＆ starting point below.</h4>
                            </div>
                            <div>
                                <v-simple-table style="margin-left:30px" dense>
                                    <thead>
                                        <tr>
                                            <th style="text-align: center; border:1px solid black">部屋名</th>
                                            <th style="text-align: center; border:1px solid black">アイテム (TV, TEL, LANが必要な箇所)</th>
                                            <th style="text-align: center; border:1px solid black">同位置に追加の場合チェック</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) in line_arr" :key="i">
                                            <td style="border:1px solid black">{{ item.room_name }}</td>
                                            <td style="border:1px solid black; text-align:center">
                                                <v-btn-toggle dense multiple style="display:inline-block">
                                                    <v-btn 
                                                        v-for="(subItem, j) in lan_items"
                                                        :key="j"
                                                        :value="subItem"
                                                        @click="toggleSelection(item, subItem)"
                                                        > 
                                                        <span :class="{ 'clicked-style': isSelected(item, subItem) }">{{ subItem }}</span> 
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </td>
                                            <td style="border:1px solid black">
                                                <v-checkbox @click="toggleAdditional(item)" v-model="item.additional" class="mt-0" label="コンセント追加 (３口)" hide-details></v-checkbox>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </div>
                            <br>
                            <div>
                                <h3 style="padding-top: 5px">（２）起点（情報ボックス位置）/ Starting Point</h3>
                                <h4 class="pl-9 pt-1">①　計画する部屋のいずれかに〇をして下さい。</h4>
                                <div>
                                    <v-btn-toggle v-model="toggle_tel" dense multiple class="pt-1 pl-9 ml-7" style="display:inline-block">
                                        <v-btn 
                                            v-for="(item, i) in group_tel"
                                            :key="i"
                                            :value="item"
                                            @click="toggleTEL(i)" 
                                            > 
                                            <span :class="{ 'clicked-style': toggle_tel[i] }" >{{ item }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                    <td class="ml-2" v-if="toggle_tel[7] == true" style="display:inline-block">
                                        <v-text-field outlined rounded dense hide-details width="120px"></v-text-field>
                                    </td>
                                </div>
                                <h4 class="pl-9 pt-2">②　インターネットの種類のいずれかにチェックして下さい。/ Internet Type</h4>
                                <div>
                                    <v-checkbox v-model="internet" v-for="(item,i) in internet_types" :key="i" :label="item" :value="item" style="display:inline-block; padding-left:60px; margin-top:0px" hide-details></v-checkbox>
                                </div>
                            </div>
                            <div style="padding-bottom:30px">
                                <h3 style="padding-top: 5px">（３）引き込み / Hikikomi</h3>
                                <h4 class="pl-9 pt-1">①　引き込み位置を指示して下さい。※各引き込みは全て同位置に計画します。電気メーターも同じ方位に計画します。/ Meter & Takeout location</h4>
                                <div>
                                    <v-btn-toggle v-model="toggle_hikikomi" dense multiple class="pt-1 pl-9 ml-7" style="display:inline-block">
                                        <v-btn 
                                            v-for="(item, i) in group_hikikomi"
                                            :key="i"
                                            :value="item"
                                            @click="toggleIntakeHikikomi(i)" 
                                            > 
                                            <span :class="{ 'clicked-style': toggle_hikikomi[i] }" >{{ item }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                    <td class="ml-2" v-if="toggle_hikikomi[7] == true" style="display:inline-block">
                                        <v-text-field outlined rounded dense hide-details width="120px"></v-text-field>
                                    </td>
                                </div>
                                <h4 class="pl-9 pt-1">①　分電盤位置 / Bundenban indication	</h4>
                                <div>
                                    <v-btn-toggle v-model="toggle_bundenban" dense multiple class="pt-1 pl-9 ml-7" style="display:inline-block">
                                        <v-btn 
                                            v-for="(item, i) in group_bundenban"
                                            :key="i"
                                            :value="item"
                                            @click="toggleBundenban(i)" 
                                            > 
                                            <span :class="{ 'clicked-style': toggle_bundenban[i] }" >{{ item }}</span> 
                                        </v-btn>
                                    </v-btn-toggle>
                                    <td class="ml-2" v-if="toggle_bundenban[1] == true" style="display:inline-block">
                                        <v-text-field outlined rounded dense hide-details width="150px"></v-text-field>
                                    </td>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <!-- SIXTH PAGE -->
                <v-tab-item>
                    <v-card flat>
                        <!-- <v-toolbar fixed flat height="30" style="background: #455a64; color:white"> -->
                            <div class="font-weight-black mt-2" style="background: #455a64; color:white;width:100%;text-indent:10px;">電気図面チェック表</div>
                        <!-- </v-toolbar> -->
                        <v-card-text class="pa-5">
                            <!-- <v-row dense>
                                <v-col cols="6"> -->
                                    <table cellspacing="0" border="0" style="padding-bottom:30px">
                                        <colgroup span="13" width="38"></colgroup>
                                        <tr>
                                            <td class="border" colspan=13 rowspan=2 height="50" style="text-align:center"><h2>電気図面チェック表</h2></td>
                                        </tr>
                                        <tr>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=5 rowspan=2 height="45">
                                                <span style="white-space:nowrap; color:black;">LED照明ﾊﾟｯｹｰｼﾞ</span> <br>
                                                <span style="white-space:nowrap; color:gray; font-size: 12px;">*個別に採用する場合は無にﾁｪｯｸ</span> <br>
                                            </td>
                                            <td class="border" style="text-align:center" rowspan=2>
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3 rowspan=2>無</td>
                                            <td class="border" style="text-align:center" rowspan=2>
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3 rowspan=2>有</td>
                                        </tr>
                                        <tr>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=5 rowspan=6 height="200">TV受信工事</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>地上波（ＵＨＦ）</td>
                                        </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>共同アンテナ</td>
                                        </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>
                                                <span style="display:inline-block;">ＣＳ</span> 
                                                <v-text-field dense hide-details outlined rounded style="display:inline-block;width:190px !important;"></v-text-field>
                                                <span style="display:inline-block">カ所</span> 
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>ＢＳ （110°ＣＳ対応）</td>
                                        </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>光テレビ</td>
                                        </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>ケーブルテレビ</td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=5 rowspan=2 height="76">TV配線外部取出</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>有　（電気図面に指示有り）</td>
                                        </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>無　（取出し不要）</td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=5 height="38">BS/CS用取出</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=2>無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=4 style="font-size:12px">有 （電気図面に指示有り）</td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=5 height="38" >ﾌﾞｰｽﾀｰ用ｺﾝｾﾝﾄ</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=2>無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=4>有</td>
                                        </tr>
                                        <tr>
                                            <td class="border" rowspan=3 height="113" style="text-align:center">分<br>配<br>器</td>
                                            <td class="border" style="text-align:center" colspan=4 rowspan=2>分配数</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>ＴＶ配線数に従う</td>
                                        </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>
                                                <span style="display:inline-block;">その他</span> 
                                                <v-text-field dense hide-details outlined rounded style="display:inline-block;width:170px !important;"></v-text-field>
                                                <span style="display:inline-block">分配</span> 
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="border" style="text-align:center" colspan=4>全端子通電型変更</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>有</td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=5 height="38" >2世帯電気工事</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>有</td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=5 rowspan=8>電気容量<br>電カ契約<br><span style="font-size:11px">※余剰電力の太陽光発電システムは</span><br><span style="font-size:11px">①の分電盤に接続します。</span></td>
                                            <td class="border" rowspan=4 style="text-align:center; font-size:large">①</td>
                                            <td class="border" colspan=7 height="50">
                                                <v-text-field dense hide-details outlined rounded style="display:inline-block;width:100px !important; left:5px;"></v-text-field>
                                                <span style="display:inline-block">　MB：</span> 
                                                <v-text-field dense hide-details outlined rounded style="display:inline-block;width:100px !important;"></v-text-field>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=2 height="50">コード</td>
                                            <td class="border" colspan=5 style="text-align:center" height="50">
                                                <v-text-field dense hide-details outlined rounded style="display:inline-block;width:100px !important;"></v-text-field>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=7 height="55"><br></td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=7 height="50"><br></td>
                                        </tr>
                                        <tr>
                                            <td class="border" rowspan=4 style="text-align:center; font-size:large">②</td>
                                            <td class="border" colspan=7 height="50">
                                                <v-text-field dense hide-details outlined rounded style="display:inline-block;width:100px !important; left:5px;"></v-text-field>
                                                <span style="display:inline-block">　MB：</span> 
                                                <v-text-field dense hide-details outlined rounded style="display:inline-block;width:100px !important;"></v-text-field>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=2 height="50">コード</td>
                                            <td class="border" colspan=5 style="text-align:center" height="50">
                                                <v-text-field dense hide-details outlined rounded style="display:inline-block;width:100px !important;"></v-text-field>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=7 height="55"><br></td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=7 height="50"><br></td>
                                        </tr>
                                        <tr>
                                            <td class="border" colspan=5 rowspan=3>太陽光発電</td>
                                            <td class="border" style="text-align:center" height="38">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>無</td>
                                        </tr>
                                        <tr>
                                            <td class="border" rowspan=2 style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3 rowspan=2 height="76">有</td>
                                            <td class="border" style="text-align:center" height="38">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>余剰電力</td>
                                            </tr>
                                        <tr>
                                            <td class="border" style="text-align:center" height="38">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3 height="38"><br>全量買取</td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=5 height="38">幹線引込～メーター</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>露出</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>隠蔽</td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=5 rowspan=4 height="151">電気ﾒｰﾀｰ取付位置<br><span style="font-size:x-small">*IUBなどのﾕﾆｯﾄ製品の背面に設置不可</span></td>
                                            <td class="border" rowspan=2 style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3 rowspan=2 style="text-align:center">電気図面に<br>指示有り</td>
                                            <td class="border" style="text-align: center;">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3><br>電気メーター</td>
                                            </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3 height="38">全量買取</td>
                                            </tr>
                                        <tr>
                                            <td class="border" rowspan=2 style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3 rowspan=2 style="text-align:center">電気図面<br>以外で指示</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>ポール等に設置：配置図参照</td>
                                            </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3 style="font-size:small">その他：施工連絡表参照</td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=3 rowspan=2 height="76">引込開閉器</td>
                                            <td class="border" colspan=2>買電用</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border">無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=5>
                                                <span style="display:inline-block">有</span> 
                                                <v-text-field dense hide-details outlined rounded style="display:inline-block;width:160px !important;"></v-text-field>
                                            </td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=2>売電用※</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border">無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=5 style="text-align:center">有 ※全量買取の場合のみ</td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=5 rowspan=4 height="151">メーターボックス<br><span style="font-size:x-small">*オプション設定品</span><br><span style="font-size:x-small">*契約容量/全量買取24kWまで対応可</span></td>
                                            <td class="border" rowspan=3 style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3 rowspan=3>有</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>Nﾎﾜｲﾄｸﾞﾚｰ</td>
                                            </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>ﾗｲﾄﾍﾞｰｼﾞｭ</td>
                                            </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>ﾀﾞｰｸﾌﾞﾗｳﾝ</td>
                                            </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>オプション設定品　選択無し</td>
                                            </tr>
                                        <tr>
                                            <td class="border" rowspan=4 height="151" style="text-align:center">分<br>電<br>盤</td>
                                            <td class="border" colspan=4 style="text-align:center">取付位置</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>電気図面に指示有り</td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=4 style="text-align:center">避雷器</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=2>無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=4>有</td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=4 style="text-align:center">感震リレー</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=2>無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=4>有</td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=4 style="text-align:center">電気送り工事</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=2>無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=4>
                                                <span style="display:inline-block">有</span> 
                                                <v-text-field dense hide-details outlined rounded style="display:inline-block;width:120px !important;"></v-text-field>
                                            </td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=5 rowspan=2 height="76">ｵﾘｼﾞﾅﾙHEMS</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>有</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>回路図面</td>
                                            </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=7>無</td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=5 rowspan=2 height="76">ｽｯｷﾘﾎﾟｰﾙ<br><span style="font-size:x-small">*契約容量/全量買取24kWまで対応可</span></td>
                                            <td class="border" rowspan=2 style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" rowspan=2>無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=5>
                                                <span style="display:inline-block">有　ﾊﾟﾀｰﾝ</span> 
                                                <v-text-field dense hide-details outlined rounded style="display:inline-block;width:110px !important;"></v-text-field>
                                            </td>
                                            </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=5>有　ﾊﾟﾀｰﾝ外</td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=5 height="38">ｽｲｯﾁ・ｺﾝｾﾝﾄﾌﾟﾚｰﾄ</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>ｽｸｴｱ</td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=5 height="38">太陽光発電表示ユニット</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>無</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>有</td>
                                            </tr>
                                        <tr>
                                            <td class="border" colspan=5 rowspan=2 height="76">ハイブリット蓄電</td>
                                            <td class="border" rowspan=2 style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" rowspan=2>無</td>
                                            <td class="border" rowspan=2 style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" rowspan=2>有</td>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>手動　切替盤</td>
                                            </tr>
                                        <tr>
                                            <td class="border" style="text-align:center">
                                                <input type="checkbox">
                                            </td>
                                            <td class="border" colspan=3>自動　切替盤</td>
                                            </tr>
                                    </table>
                                <!-- </v-col>
                            </v-row> -->
                        </v-card-text>
                    </v-card>
                </v-tab-item>

            </v-tabs>
        </v-container>
    </v-card>
    </v-dialog>
</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props: {
        dialog : Boolean
    },
    data: () => ({
        defaultTab: 0,
        shomeiData: [],
        getAllShomei : [],

        // -------1ST PAGE VARIABLES-------
        // LIGHTING FOR LED PACKAGE
        shomeiOption1Obj: {
            option1: '1',
            sub_option: {
                value: null,
                sub_option_remarks: [],
                sub_option_remarks_text : null
            }
        },
        shomeiOption2Obj: {
            option1: '2',
            sub_option: {
                value: null,
                sub_option_remarks: [],
                sub_option_remarks_text : null
            }
        },
        shomeiOption3Obj: {
            option1: '3',
            sub_option: {
                value: null,
                sub_option_remarks: [],
                sub_option_remarks_text : null
            }
        },
        shomeiOption4Obj: {
            option1: '4',
            sub_option: {
                value: null,
                sub_option_remarks: [],
                sub_option_remarks_text : null
            }
        },
        shomeiOption5Obj: {
            option1: '5',
            sub_option: {
                value: null,
                sub_option_remarks: [],
                sub_option_remarks_text : null
            }
        },
        shomeiOption6Obj: {
            option1: '6',
            sub_option: {
                value: null,
                sub_option_remarks: [],
                sub_option_remarks_text : null
            }
        },

        // -------3RD PAGE VARIABLES-------
        switchesData : [],
        getAllSwitches : [],
        switchesOption1Obj : {
            option1: null,
            sub_outlet : {
                value: null,
                sub_outlet_remarks: [],
                sub_outlet_remarks_text : null
            }
        },
        switchesOption2Obj : {
            option2 : null,
            sub_outlet : {
                value: null,
                sub_outlet_remarks : [],
                sub_outlet_remarks_text : null
            }
        },
        switchesOption3Obj : {
            option3 : null,
            sub_outlet : {
                value: null,
                sub_outlet_remarks : [],
                sub_outlet_remarks_text : null
            }
        },
        switchesOption4Obj : {
            option4 : null,
            sub_outlet : {
                value: null,
                sub_outlet_remarks : [],
                sub_outlet_remarks_text : null
            }
        },
        switchesOption5Obj : {
            option5 : null,
            sub_outlet_with : {
                value : null,
                sub_outlet_remarks : [],
                sub_outlet_remarks_text : null,
            },
            sub_outlet_without : {
                value : null,
                sub_outlet_remarks : [],
                sub_outlet_remarks_text : null,
            }
        },
        switchesOption6Obj : {
            option6 : null,
            sub_outlet : {
                value: '6',
                sub_outlet_remarks : [],
                sub_outlet_remarks_text : null
            }
        },
        switchesOption7Obj : {
            option7 : null,
            sub_outlet_thermal : {
                value: null,
                sub_outlet_remarks : [],
                sub_outlet_remarks_text : null
            },
            sub_outlet_sensor : {
                value: null,
                sub_outlet_remarks : [],
                sub_outlet_remarks_text : null
            }
        },


        shomei1: null,
        shomei1Options: [
            {text: "①提案プラン（計画頻度の高い提案を加えて計画します。） /　Upper Type", desc: "※玄関ポーチ・勝手口照明センサー有、駐車スペースにスポットライト等/ Exterior Light with sensor & spot light for parking space", value:1},
            {text: "②標準プラン（標準の照明・スイッチの配線数で計画します。） / Standard Type", value:2},
            {text: "③全て図面に従う / Follow the Request", desc: "※全て添付ＣＡＤ図面（配線位置が記入されたもの）通りに作図する場合はここをチェックして下さい。", value:3},
        ],
        shomei2: null,
        selected: [],
        shomei3: null,
        shomei3Options: [
            {text: "①【推奨】１ヶ所に２個以上のスイッチが集中した箇所は「ネームスイッチ」とする。 / Design switch as Name if 2 or more in same position", value:1},
            {text: "②すべてのスイッチを「ネームスイッチ」とする。 / Design all switch as Name", value:2},
            {text: "	③「ネームスイッチ」なし / No need to design Name", value:3},
            {text: "④全て図面に従う  / Follow the Request", desc: "※全て添付ＣＡＤ図面（配線位置が記入されたもの）通りに作図する場合はここをチェックして下さい。", value:4},
        ],
        longtext1: '選択した部屋のダウンライトカラー（ライトシリアル）を選択します。 *選択しない場合、キッチンは昼白色（MN）になります。それ以外の場合は電球色で計画します。 /\nSelect the downlight color (light serial) of the selected room. * If not selected, the kitchen will be lunch white (MN), otherwise plan with bulb color.',
        longtext2: 'ペンダント照明　※タイプ、色品番双方に選択がない場合、対応できません。 /\nPendant light *If not selected properly, no need to follow. If color is not selected, first option can be used. ',
    
        // -------2ND PAGE VARIABLES-------
        outlet: null,
        outletOptions: [
            {text: "①提案プラン（計画頻度の高い提案を加えて計画します。） /　Upper Type", value:1},
            {text: "②標準プラン（標準のコンセント配線数で計画します。） / Standard Type", value:2},
            {text: "③全て図面に従う  / Follow the Request", desc: "※全て添付ＣＡＤ図面（配線位置が記入されたもの）通りに作図する場合はここをチェックして下さい。", value:3},
        ],

        // -------3RD PAGE VARIABLES-------
        optional_switch_timer : null,
        optional_switch_open : null,
        optional_switch_remote : null,
        optional_switch_led : null,
        toggle_multiple1 : Array(2).fill(false),
        toggle_multiple2 : Array(7).fill(false),
        toggle_multiple3 : Array(7).fill(false),
        toggle_multiple4 : Array(7).fill(false),
        toggle_multiple5 : Array(6).fill(false),
        toggle_multiple6 : Array(6).fill(false),
        toggle_multiple7 : Array(3).fill(false),
        toggle_multiple8 : Array(3).fill(false),
        group_button1 : [
                {text: '標準で壁付かってにスイッチが1・2Fホール、1・2Fトイレに計画されます。', value:'switch_12f'}, 
                {text:'その他', value:'switch_others'}
        ],
        group_button2 : [
            {text: '玄関ﾎｰﾙ', value:'timer_eha'},
            {text: 'ｼｭ-ｽﾞｸﾛｰｸ', value:'timer_sic'},
            {text: 'ﾘﾋﾞﾝｸﾞ', value:'timer_liv'},
            {text: 'ﾀﾞｲﾆﾝｸﾞ', value:'timer_dine'},
            {text: '大壁和室', value:'timer_jo'},
            {text: '門灯（門柱ﾕﾆｯﾄ含む）', value:'timer_gate'},
            {text: 'その他', value:'timer_others'},
        ],
        group_button3 : [
            {text: '1Fﾎｰﾙ', value:'outlet_1f'},
            {text: '2Fﾎｰﾙ', value:'outlet_2f'},
            {text: 'ｳｫｰｸｲﾝｸﾛｰｾﾞｯﾄ', value:'outlet_wic'},
            {text: 'ﾘﾋﾞﾝｸﾞ', value:'outlet_liv'},
            {text: '洋室', value:'outlet_br'},
            {text: '洋室（２）', value:'outlet_br2'},
            {text: 'その他', value:'outlet_others'},
        ],
        group_button4 : [
            {text: 'ﾘﾋﾞﾝｸﾞ', value:'led_liv'},
            {text: 'ｼｱﾀｰﾙｰﾑ', value:'led_theater'},
            {text: '主寝室', value:'led_mbr'},
            {text: '洋室', value:'led_br'},
            {text: '洋室（２）', value:'led_br2'},
            {text: '洋室（３）', value:'led_br3'},
            {text: 'その他', value:'led_others'}
        ],
        group_button5 : [
            {text: '主寝室', value:'remote_mbr'},
            {text: '洋室', value:'remote_br'},
            {text: '洋室（２）', value:'remote_br2'},
            {text: '洋室（３）', value:'remote_br3'},
            {text: '書斎', value:'remote_s'},
            {text: 'その他', value:'remote_others'},
        ],
        group_button6 : [
            {text: '1Fホール', value:'foot_eha1f'},
            {text: '2Fホール', value:'foot_eha2f'},
            {text: 'その他', value:'foot_others'},
        ],

        // -------4TH PAGE VARIABLES-------
        toggle_interphone1 : Array(4).fill(false),
        toggle_interphone2 : Array(4).fill(false),
        toggle_interphone3 : Array(10).fill(false),
        toggle_interphone4 : Array(10).fill(false),
        group_interphone1: ['ﾎﾟｰﾁ', 'ﾎﾟｰﾁ（２）', '門（外部に取出）', '勝手口'],
        image_name1: ['mt101', 'mt102', 'mt103', 'mt104'],
        image_name2: ['mt105', 'mt91', 'mt92'],
        group_interphone2: ['ﾘﾋﾞﾝｸﾞ', ' ﾘﾋﾞﾝｸﾞ（２）', 'ﾀﾞｲﾆﾝｸﾞ', 'ﾀﾞｲﾆﾝｸﾞ（２）', 'ｷｯﾁﾝ', 'ｷｯﾁﾝ（２）', 'ﾘﾓｺﾝﾆｯﾁ', '1Fﾎｰﾙ', '2Fﾎｰﾙ', 'その他'],

        // -------5TH PAGE VARIABLES-------
        line_arr : [
            {
                room_name : 'リビング',
                selectedItems : [],
                additional : null

            },
            {
                room_name : 'ダイニング',
                selectedItems : [],
                additional : null
            },
            {
                room_name : '主寝室',
                selectedItems : [],
                additional : null
            },
            {
                room_name : '洋室',
                selectedItems : [],
                additional : null
            },
            {
                room_name : '洋室（２）',
                selectedItems : [],
                additional : null
            },
            {
                room_name : '洋室（３）',
                selectedItems : [],
                additional : null
            },
            {
                room_name : '洋室（４）',
                selectedItems : [],
                additional : null
            },
            {
                room_name : '大壁和室',
                selectedItems : [],
                additional : null
            },
            {
                room_name : '書斎',
                selectedItems : [],
                additional : null
            },
            {
                room_name : 'ファミリールーム',
                selectedItems : [],
                additional : null
            },
            {
                room_name : 'その他',
                selectedItems : [],
                additional : null
            },
        ],
        lan_items : [ 'ＪＣ', 'ＪＣＴ', 'ＪＣＬ', 'ＴＶ', 'ＴＥＬ配管', 'ＴＥＬ配線配管', 'ＬＡＮ配管', 'ＬＡＮ配線配管' ],
        toggle_tel : Array(8).fill(false),
        toggle_hikikomi : Array(4).fill(false),
        toggle_bundenban : Array(2).fill(false),
        group_tel: [ '1Fｳｫｰｸｲﾝｸﾛｰｾﾞｯﾄ', '2Fｳｫｰｸｲﾝｸﾛｰｾﾞｯﾄ', '1Fﾎｰﾙ', '2Fﾎｰﾙ', '階段下物入', '納戸', '書斎', 'その他'],
        group_hikikomi : [ '北東', '南東', '南西', '北西' ],
        group_bundenban : [ '洗面所に計画します。（スペースが無い場合はホール）', 'その他の部屋に計画' ],
        internet : null,
        internet_types : [ '光 / Hikari', 'TEL', 'NET', '空配管 Φ22 / Empty Haikan kigou 22	' ],
    }),

    computed: {
        ...mapState([
            'cadRequestRevisionContent',
            'editMode',
            'editCadRequestRevisionContent',
            'cadRequestPdr',
        ]),

        selected_internet() {
            return this.internet !== null ? [this.internet] : []
        }
    },

    methods: {
        // OPTION 1 LIGHTING -> FIRST PAGE
        pushSubRemToObj(){
            this.shomeiData = []
            if(this.shomeiOption1Obj.sub_option.value == '1'){
                if(this.shomeiOption1Obj.sub_option.value == '1'){
                    this.shomeiData = this.shomeiOption1Obj
                }
            } 
            if(this.shomeiOption2Obj.sub_option.value == '2'){
                if(this.shomeiOption2Obj.sub_option.value == '2'){
                    this.shomeiData = this.shomeiOption2Obj
                }
            }
            if(this.shomeiOption3Obj.sub_option.value == '3'){
                if(this.shomeiOption3Obj.sub_option.value == '3'){
                    this.shomeiData = this.shomeiOption3Obj
                }
            }
            if(this.shomeiOption4Obj.sub_option.value == '4'){
                if(this.shomeiOption4Obj.sub_option.value == '4'){
                    this.shomeiData = this.shomeiOption4Obj
                }
            }
            if(this.shomeiOption5Obj.sub_option.value == '5'){
                if(this.shomeiOption5Obj.sub_option.value == '5'){
                    this.shomeiData = this.shomeiOption5Obj
                }
            }
            if(this.shomeiOption6Obj.sub_option.value == '6'){
                if(this.shomeiOption6Obj.sub_option.value == '6'){
                    this.shomeiData = this.shomeiOption6Obj
                }
            }
            console.log(this.shomeiData, 'shomeiData')
        },
        pushToObj(){
            this.shomeiData = [];
            if(this.shomeiOption1Obj.sub_option.value == '1'){
                this.shomeiData.push(this.shomeiOption1Obj)
            }
            if(this.shomeiOption2Obj.sub_option.value == '2') {
                this.shomeiData.push(this.shomeiOption2Obj)
            }
            if(this.shomeiOption3Obj.sub_option.value == '3') {
                this.shomeiData.push(this.shomeiOption3Obj)
            }
            if(this.shomeiOption4Obj.sub_option.value == '4') {
                this.shomeiData.push(this.shomeiOption4Obj)
            }
            if(this.shomeiOption5Obj.sub_option.value == '5') {
                this.shomeiData.push(this.shomeiOption5Obj)
            }
            if(this.shomeiOption6Obj.sub_option.value == '6') {
                this.shomeiData.push(this.shomeiOption6Obj)
            }
            // console.log(this.shomeiOption1Obj, 'this.shomeiOption1Obj.sub_option.value', this.shomeiData)
            console.log(this.shomeiData, 'shomeiData Option')
            this.getAllShomei = this.shomeiData
        },

        // SWITCHES THIRD PAGE
        pushToSwitchObj(){
            this.switchesData = [];
            if(this.switchesOption1Obj.option1 == '1'){
                this.switchesData.push(this.switchesOption1Obj)
            }
            if(this.switchesOption2Obj.option2 == '2'){
                this.switchesData.push(this.switchesOption2Obj)
            }
            if(this.switchesOption3Obj.option3 == '3'){
                this.switchesData.push(this.switchesOption3Obj)
            }
            if(this.switchesOption4Obj.option4 == '4'){
                this.switchesData.push(this.switchesOption4Obj)
            }
            if(this.switchesOption5Obj.option5 == '5'){
                this.switchesData.push(this.switchesOption5Obj)
            }
            if(this.switchesOption6Obj.option6 == '6'){
                this.switchesData.push(this.switchesOption6Obj)
            }
            if(this.switchesOption7Obj.option7 == '7'){
                this.switchesData.push(this.switchesOption7Obj)
            }

            this.getAllSwitches = this.switchesData
            console.log(this.getAllSwitches,'getAllSwitches')
        },
        pushSubOutletObj(){
            this.switchesData = [];
            if(this.switchesOption1Obj.option1 == '1'){
                if(this.switchesOption1Obj.option1 == '1'){
                    this.switchesData = this.switchesOption1Obj
                }
            }
            if(this.switchesOption2Obj.option2 == '2'){
                if(this.switchesOption2Obj.option2 == '2'){
                    this.switchesData = this.switchesOption2Obj
                }
            }
            if(this.switchesOption3Obj.option3 == '3'){
                if(this.switchesOption3Obj.option3 == '3'){
                    this.switchesData = this.switchesOption3Obj
                }
            }
            if(this.switchesOption4Obj.option4 == '4'){
                if(this.switchesOption4Obj.option4 == '4'){
                    this.switchesData = this.switchesOption4Obj
                }
            }
            if(this.switchesOption5Obj.option5 == '5'){
                if(this.switchesOption5Obj.option5 == '5'){
                    this.switchesData = this.switchesOption5Obj
                }
            }
            if(this.switchesOption6Obj.option6 == '6') {
                if(this.switchesOption6Obj.option6 == '6'){
                    this.switchesData = this.switchesOption6Obj
                }
            }
            if(this.switchesOption7Obj.option7 == '7'){
                if(this.switchesOption7Obj.option7 == '7'){
                    this.switchesData = this.switchesOption7Obj
                }
            }


            console.log(this.switchesData,'this.switchesData')
        },
        // END OF OPTION 1 LIGHTING -> FIRST PAGE
        submitProposal(){
            console.log(this.shomeiData, 'shomeiData')
            let data_pdr = {
                lighting : {
                    option_1: this.shomei1,
                    option_2: this.shomei2 === "1" ? this.getAllShomei : this.shomei2,
                    option_3: this.shomei3
                },
                outlet_wiring : {
                    option : this.outlet,
                },
                optional_switch_outlet : {
                    outlet_option : this.getAllSwitches,
                },
                intercom : {
                    standard : null,
                    interphone_type : null,
                    interphone_unit : null,
                },
                tv_tel_lan : {
                    standard : null,
                    planning : null,
                    starting_point : null,
                    hikikomi : null,
                },
                electrical_drawing_checklist : {
                    led_lighting_package : null,
                    tv_reception_construction : null,
                    tv_wiring_external : null,
                    bs_cs : null,
                    booster_outlet : null,
                    distributor : null,
                    household_electrical_work : null,
                    capacitance_electricity_contract : null,
                    solar_power : null,
                    main_line_meter : null,
                    electric_meter : null,
                    back_unit_product : null,
                    retractable_switch : null,
                    meter_box : null,
                    distribution_board : null,
                    hems : null,
                    sukkiri_pol : null,
                    concentrate_plate : null,
                    solar_power_display : null,
                    hybrid_energy : null,
                }
            }
            // PDR LIGHTING
            if ((data_pdr.lighting.option_1 !== null && data_pdr.lighting.option_1 !== undefined) || (data_pdr.lighting.option_2 !== null && data_pdr.lighting.option_2 !== undefined) || (data_pdr.lighting.option_3 !== null && data_pdr.lighting.option_3 !== undefined)) {
                // If at least one option has data, update the lighting options
                data_pdr.lighting = {
                                        option_1: this.shomei1,
                                        option_2: this.shomei2 === "1" ? this.getAllShomei : this.shomei2,
                                        option_3: this.shomei3
                                    };
            } else {
                // If none of the options has data, remove the properties inside lighting
                data_pdr.lighting = {};
            }
            // PDR OUTLET WIRING
            if(data_pdr.outlet_wiring.option !== null && data_pdr.outlet_wiring.option !== undefined){
                data_pdr.outlet_wiring = {
                                                option : this.outlet,
                                            }
            } else {
                data_pdr.outlet_wiring = {
                                                option : null,
                                            }
            }
            // PDR OPTION SWITCH OUTLET








            
            this.$emit('submitProposal',data_pdr)
            this.$store.state.cadRequestPdr = data_pdr
            this.toggleDialogDenkiRequest(false)
        },

        cancelProposal(){
            this.toggleDialogDenkiRequest(false)
        },

        toggleDialogDenkiRequest(value){
            this.$emit('toggleDialogDenkiRequest', value)
        },
        toggle1(i) {
			this.$set(this.toggle_multiple1, i, !this.toggle_multiple1[i])
		},
		toggle2(i) {
			this.$set(this.toggle_multiple2, i, !this.toggle_multiple2[i])
		},
		toggle3(i) {
			this.$set(this.toggle_multiple3, i, !this.toggle_multiple3[i])
		},
		toggle4(i) {
			this.$set(this.toggle_multiple4, i, !this.toggle_multiple4[i])
		},
        toggle5(i) {
			this.$set(this.toggle_multiple5, i, !this.toggle_multiple5[i])
		},
        toggle6(i) {
			this.$set(this.toggle_multiple6, i, !this.toggle_multiple6[i])
		},
        toggle7(i) {
			this.$set(this.toggle_multiple7, i, !this.toggle_multiple7[i])
		},
        toggle8(i) {
			this.$set(this.toggle_multiple8, i, !this.toggle_multiple8[i])
		},
        toggleIP1(i) {
			this.$set(this.toggle_interphone1, i, !this.toggle_interphone1[i])
		},
        toggleIP2(i) {
			this.$set(this.toggle_interphone2, i, !this.toggle_interphone2[i])
		},
        toggleIP3(i) {
			this.$set(this.toggle_interphone3, i, !this.toggle_interphone3[i])
		},
        toggleIP4(i) {
			this.$set(this.toggle_interphone4, i, !this.toggle_interphone4[i])
		},
        isSelected(item, subItem) {
            return item.selectedItems && item.selectedItems.includes(subItem);
        },
        toggleSelection(item, subItem) {
            console.log(item, subItem)
            if (!item.selectedItems) {
                this.$set(item, 'selectedItems', []);
            }

            const index = item.selectedItems.indexOf(subItem);

            if (index === -1) {
                // Add the item to the selection
                this.$set(item.selectedItems, item.selectedItems.length, subItem);
            } else {
                // Remove the item from the selection
                this.$delete(item.selectedItems, index);
            }
        },
        toggleAdditional(item) {
            console.log(item)
        },
        toggleTEL(i) {
			this.$set(this.toggle_tel, i, !this.toggle_tel[i])
		},
        toggleIntakeHikikomi(i) {
            this.$set(this.toggle_hikikomi, i, !this.toggle_hikikomi[i])
        },
        toggleBundenban(i) {
            this.$set(this.toggle_bundenban, i, !this.toggle_bundenban[i])
        },

        getMaxHeight(imageName) {
            return imageName === 'mt101' ? 120 : 150;
        },
        getMaxWidth(imageName) {
            return imageName === 'mt101' ? 120 : 250;
        },
    },

    // watch:{
    //     '$store.state.cadRequestPdr'(val){
    //         this.shomei1 = val.lighting
    //     }
    // },
}
</script>

<style>
.theme--light.v-label {
    color: black;
}
.custom-tab {
  background-color: #455a64;
}


.clicked-style {
    /* border-radius : 50%; */
    border : 3px solid red;
}
.border {
    border-top: 1px solid #000000; 
    border-bottom: 1px solid #000000; 
    border-left: 1px solid #000000; 
    border-right: 1px solid #000000
}
.theme--light.v-card>.v-card__subtitle, .theme--light.v-card>.v-card__text {
    color: rgb(0 0 0);
}

.custom-dialog.v-dialog{
    margin-top: 70px;
}


/* .v-text-field .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
} */
</style>